<template class="full-height">
  <div class="socket-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-tabs v-model="tabName" type="border-card">
      <el-tab-pane label="回傳全紀錄" name="positionLogs">
        <div style="height: 100%">
          <position-log></position-log>
        </div>
      </el-tab-pane>
      <el-tab-pane label="旅遊團紀錄" name="travelLogs">
        <div style="height: 100%">
          <position-travel-log></position-travel-log>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import PositionLog from './components/positionLogComponent.vue'
import PositionTravelLog from './components/positionTravelLogComponent.vue'
// import SdpLogs from "./components/sdpLogsComponent.vue";

export default {
  name: 'AppPosition',
  components: {
    Pagination,
    PositionLog,
    PositionTravelLog,
  },
  data() {
    return {
      tabName: 'positionLogs',
    }
  },
  async created() {},
  methods: {},
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.el-tabs--card {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}
.el-tab-pane {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
